import { CircularProgress, Divider } from "@mui/joy";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../Shared/CustomButton";
import CustomDiv from "../../../Shared/CustomDiv";
import Text from "../../../Shared/Text";
import { Link, useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { API_URLS } from "../../../Config/API_URLS";
import axiosInstance from "../../../Config/axios";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import { checkPincodeFn } from "../../../Services/CheckPincode";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import pen from "../../../images/pen.svg";

const ProductPage = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState([]);
  const [tab, setTab] = useState("Description");
  const [variantColor, setVariantColor] = useState(0);
  const [variantStorage, setVariantStorage] = useState(0);
  const [variant, setVariant] = useState("");
  const [pincode, setPincode] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
  };

  const navigate = useNavigate();

  const productDetailData = () => {
    const reqbody = new FormData();
    reqbody.append("product_id", id);

    setIsLoading(true);
    axiosInstance
      .post(
        `api/store/new-product-deatils/?variant_color_value_id=${variantColor}&variant_storage_value_id=${variantStorage}&other_variants_value_id=${variant}`,
        reqbody
      )
      .then((response) => {
        setIsLoading(false);
        setDetail(
          response.data.data[0].product_deatils[0]?.product_variant_value_list
        );
        setData(response.data.data[0].related_products);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const bariant = detail?.product_variant_value_list;
  const product_specification = bariant?.[0]?.product_specification;

  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const client = useQueryClient();
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  useEffect(
    () => {
      productDetailData();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    // eslint-disable-next-line
    [variant, variantColor, variantStorage, id]
  );

  const emptyFunction = () => {};
  const { mutate } = useMutation(checkPincodeFn, {
    onSuccess: (response) => {
      response.data.response_code === 200
        ? setDelivery(
            `Delivery within ${response.data.delivery_time} in ${response.data.city_name}`
          )
        : emptyFunction();
    },
  });

  useEffect(
    () => {
      pincode.length === 6 ? mutate({ zipcode: pincode }) : emptyFunction();
    },
    // eslint-disable-next-line
    [pincode]
  );
  console.log(detail?.product_variant_value_list?.variant_id);
  return isLoading ? (
    <>
      <CustomDiv className="flex h-[90vh] justify-center items-center">
        <CircularProgress size="lg" color="primary" />
      </CustomDiv>
    </>
  ) : (
    <CustomDiv className="flex flex-col overflow-x-hidden bg-gray-100  shadow px-[2%] lg:px-[8%] py-[4%] w-full">
      <CustomDiv className="lg:flex-col justify-center">
        <CustomDiv className="grid lg:grid-cols-3 grid-rows-3 w-full ">
          {detail?.map((detail) => {
            return (
              <>
                <div className="pr11">
                  <div className=" pr12 my-10">
                    <div className="pr311  background background1"></div>
                    <div className=" pr14 !h-auto !p-4  card ">
                      <div className="pr15">
                        <p className="lg:!text-2xl capitalize  ">
                          {detail?.variant_name}
                        </p>{" "}
                        <p className="font-bold text-center py-2  text-blue-800 lg:text-2xl ">
                          <span className="font-bold lg:text-xl text-black">
                            ₹.
                          </span>{" "}
                          {detail?.actual_price}
                        </p>{" "}
                        {detail?.product_specification
                          ?.slice(0, 1)
                          .map((item) => {
                            return (
                              <>
                                <div className="!text-red-800 font-bold lg:text-xl py-1">
                                  {item?.product_specification_category?.map(
                                    (val) => {
                                      return (
                                        <>
                                          <div className="flex justify-center gap-3  text-black text-sm">
                                            <p className=" text-purple-800 w-52 overflow-hidden">
                                              {val?.specification_value}
                                            </p>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </>
                            );
                          })}
                      </div>

                      <button className="pr23 !my-0">
                        <div className="pr24 ">
                          <div className="pr25">
                            <img alt="" src={pen} className="" />
                          </div>
                        </div>
                        <span className="mx-1">
                          <CustomButton
                            className=" !text-lg !border-none !font-bold"
                            variant="outlined"
                            onClick={(event) =>
                              navigate(`/plan/${detail?.variant_id}`)
                            }
                          >
                            Subscribe
                          </CustomButton>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </CustomDiv>
      </CustomDiv>

      <Text className="text-xl my-5 font-bold">Product Description</Text>
      <CustomDiv className="bg-white shadow flex flex-col">
        <CustomDiv className="flex gap-3 px-2">
          {["Description"].map((item) => {
            return (
              <Link onClick={() => setTab(item)} to="#">
                <Text
                  className={classNames(
                    "border-b-2 border-red-500 border-opacity-0 hover:border-opacity-100 p-2",
                    tab === item ? "!border-opacity-100 !text-red-500" : ""
                  )}
                >
                  {item}
                </Text>
              </Link>
            );
          })}
        </CustomDiv>
        <Divider />
        <CustomDiv>
          <p
            className="p-5"
            dangerouslySetInnerHTML={{ __html: detail?.description }}
          ></p>
        </CustomDiv>
      </CustomDiv>
      <CustomDiv className="my-5">
        <Text className="text-xl font-semibold">Related Products</Text>
        <CustomDiv className="flex gap-14 my-5 py-1 w-full overflow-x-auto">
          {data?.map((product) => {
            return (
              <CustomDiv
                className="rounded-md h-fit w-[250px] duration-200 shadow  cursor-pointer "
                onClick={() => navigate(`/product/${product?.product_id}`)}
              >
                <div className="pr11 mt-10">
                  <div className=" pr12 ">
                    <div className="pr311  background background1"></div>
                    <div className=" pr14 card">
                      <div className="pr15">
                        <span className="centerdiv">
                          <img
                            src={product.product_image}
                            alt=""
                            className="h-24 relative"
                          />
                        </span>
                        <CustomDiv className="flex flex-col justify-between p-4 space-y-2">
                          <CustomDiv className="space-y-2">
                            <Text className="text-lg class-name font-semibold">
                              {product.variant_name}
                            </Text>
                          </CustomDiv>
                          <Text className="text-sm uppercase">
                            {product.main_category}
                          </Text>
                          <CustomDiv className="flex items-center gap-1">
                            <Text className="font-bold">₹{product.price}</Text>
                            <Text className="font-bold text-xl"></Text>
                            <Text className="text-green-600">
                              {product.discount_percent !== "0.0"
                                ? `(${product.discount_percent?.split(
                                    ".0"
                                  )})% OFF`
                                : null}
                            </Text>
                          </CustomDiv>
                        </CustomDiv>
                      </div>
                      <button className="pr23 ">
                        <div className="pr24 ">
                          <div className="pr25">
                            <img alt="" src={pen} className="" />
                          </div>
                        </div>
                        <span className="mx-1">
                          <div
                            className="pr27 pt-2 font-bold"
                            onClick={() => navigate(`/product/${product?.id}`)}
                          >
                            See More
                            <p className="pr29"></p>
                          </div>
                        </span>
                      </button>

                      <div className="flex justify-center lg:py-5 py-2">
                        <div className="bg-white rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <span className="centerdiv">
                  <img
                    src={product.product_image}
                    alt=""
                    className="h-52 relative"
                  />
                </span>
                <CustomDiv className="flex flex-col justify-between p-4 space-y-2">
                  <CustomDiv className="space-y-2">
                    <Text className="text-lg class-name font-semibold">
                      {product.variant_name}
                    </Text>
                  </CustomDiv>
                  <Text className="text-sm uppercase">
                    {product.main_category}
                  </Text>
                  <CustomDiv className="flex items-center gap-1">
                    <Text className="font-bold">₹{product.price}</Text>
                    <Text className="font-bold text-xl">
                      
                    </Text>
                    <Text className="text-green-600">
                      {product.discount_percent !== "0.0"
                        ? `(${product.discount_percent?.split(".0")})% OFF`
                        : null}
                    </Text>
                  </CustomDiv>
                  <span className="flex gap-4">
                   
                    <CustomButton
                      type="button"
                      className="!rounded w-full"
                      onClick={(event) =>
                        localStorage.getItem("token")
                          ? addToCart(event, product.variant_id)
                          : handleLogin()
                      }
                    >
                      Add To Cart
                    </CustomButton>
                  </span>
                </CustomDiv> */}
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv>
    </CustomDiv>
  );
};

export default ProductPage;
